import { useMemo } from 'react'

import { useDetailViewContext } from 'features/views/DetailView/hooks/useDetailViewContext'

export function useDetailViewLayoutState() {
    const { view, recordManager } = useDetailViewContext()!

    const layoutType = view?.layout?.type ?? 'compact'

    const isError = recordManager.isError
    const onRetry = recordManager.refetch
    const isNotFoundError = recordManager.isNotFoundError

    return useMemo(
        () => ({
            layoutType,
            isError,
            onRetry,
            isNotFoundError,
        }),
        [layoutType, isError, onRetry, isNotFoundError]
    )
}
